import {
  CreateAssessmentPayload,
  DeleteAssessmentRequest,
  SaveJobRotationRequest,
} from "src/store/createJobRotationAssessmentSlice";
import apiClient from "src/utils/apiClient";
class JobRotationAssessmentService {
  async getAllJobRotationAssessments(
    assessmentSite: string,
    calculationV2?: boolean,
  ) {
    return await apiClient.get(
      `/getJobRotationAssessments/${assessmentSite}${
        calculationV2 ? "?calculationV2=true" : ""
      }`,
    );
  }
  async createJobRotationAssessment(payload: CreateAssessmentPayload) {
    const { data } = await apiClient.post(
      `/createJobRotationAssessment`,
      payload,
    );
    return {
      preSignedUrlList: data.preSignedUrlList as string[],
      ergoNetPreSignedUrlList: data.ergoNetPreSignedUrlList as string[],
    };
  }
  async uploadVideoToS3(preSignedUrl: string, file: File, retries: number) {
    for (let attempt = 0; attempt < retries; attempt++) {
      try {
        const response = await fetch(preSignedUrl, {
          method: "PUT",
          body: file,
          headers: {
            "Content-Type": file.type,
            "x-amz-expected-bucket-owner": "453145159581",
          },
        });
        if (!response.ok) {
          throw new Error("Something went wrong while uploading videos");
        }
        return response;
      } catch (error) {
        console.error(`upload attempt ${attempt + 1} failed`, error);
      }
    }
    console.error("All attempts failed");
  }
  async getJobRotationAssessmentDetails(
    assessmentId: string,
    calculationV2?: boolean,
  ) {
    return await apiClient.get(
      `/getJobRotationAssessmentDetails/${assessmentId}${
        calculationV2 ? "?calculationV2=true" : ""
      }`,
    );
  }
  async saveJobRotationAssessment(
    saveJobRotationRequest: SaveJobRotationRequest,
  ) {
    return await apiClient.post(
      `/saveJobRotationAssessment`,
      saveJobRotationRequest,
    );
  }
  async getJobRotationMetadata() {
    return apiClient.get("/getJobRotationMetadata");
  }
  async deleteJobRotationAssessment(
    deleteAssessmentRequest: DeleteAssessmentRequest,
  ) {
    return apiClient.post("/deleteJobRotationAssessment", {
      assessmentId: deleteAssessmentRequest.deletedAssessment.assessmentId,
      deletedBy: deleteAssessmentRequest.deletedBy,
    });
  }
  async finalizeJobRotationAssessment(finalizePayload: SaveJobRotationRequest) {
    const response = await apiClient.post(
      `/saveJobRotationAssessment`,
      finalizePayload,
    );
    if (response.status === 200) {
      let payload: SaveJobRotationRequest = {
        assessmentId: finalizePayload.assessmentId,
        updatedBy: finalizePayload.updatedBy,
      };
      if (finalizePayload.calculationV2) {
        payload = { ...payload, calculationV2: finalizePayload.calculationV2 };
      }
      const response = await apiClient.post("/finalizeJobRotationAssessment", {
        assessmentId: finalizePayload.assessmentId,
        updatedBy: finalizePayload.updatedBy,
        calculationV2: finalizePayload.calculationV2,
      });
      return response;
    }
  }
  async editCompletedJobRotationAssessment(
    editAssessmentRequest: SaveJobRotationRequest,
  ) {
    const response = await apiClient.post(
      `/editCompletedJobRotationAssessment`,
      editAssessmentRequest,
    );
    if (response.status === 200) {
      const response = await apiClient.post("/finalizeJobRotationAssessment", {
        assessmentId: editAssessmentRequest.assessmentId,
        updatedBy: editAssessmentRequest.updatedBy,
        calculationV2: editAssessmentRequest.calculationV2,
      });
      return response;
    }
  }
}
export default new JobRotationAssessmentService();
